import * as Sentry from '@sentry/browser'
import { kAgentV2RouterApiBasePath } from '@/constants/constants-api-paths'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { getResponseDebugContext, getTopLevelKeys } from '@/util/api/response-body'
import { ApiResponsePayloadError } from '@/util/errors/api-response-payload-error'
import { z } from 'zod'
import { agentV2Request } from './agent-v2-request'

const lawStatusSchema = z.object({ has_stale_law: z.boolean() })

export async function getConversationLawStatus(conversationId: string, signal?: AbortSignal): Promise<{ has_stale_law: boolean }> {
  const url = `${kPaxtonAppApiRESTBaseUrl()}${kAgentV2RouterApiBasePath}/conversations/${conversationId}/law-status`
  return agentV2Request({
    url,
    method: 'GET',
    signal,
    sentryEndpoint: 'GET /api/v2/agent/conversations/{conversation_id}/law-status',
    parseResponse: (data, { response, sentryTags }) => {
      const parsed = lawStatusSchema.safeParse(data)
      if (parsed.success) return parsed.data

      Sentry.withScope((scope) => {
        scope.setTags(sentryTags)
        Sentry.captureException(new Error('Agent v2 conversation law status response schema validation failed'), {
          extra: {
            ...getResponseDebugContext(response, url),
            conversationId,
            responseKeys: getTopLevelKeys(data),
            issues: parsed.error.issues,
          },
        })
      })
      throw new ApiResponsePayloadError(response.status, 'Invalid Agent v2 conversation law status response shape', parsed.error.issues)
    },
  })
}
